import userManage from './userManage'
export default userManage
